import clsx from "clsx";
import "./CreateReservationModal.scss";
import { BaseModal } from "@/components";
import { CreateReservationModalFooter } from "@/components/ui/CreateReservationModal/CreateReservationModalFooter";
import { CreateReservationModalContent } from "@/components/ui/CreateReservationModal/CreateReservationModalContent";

type CreateReservationModalProps = {
  open: boolean;
  overrideClassNames?: string;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
};

const CreateReservationModal = ({
  open,
  overrideClassNames,
  setOpen,
  children,
}: CreateReservationModalProps) => {
  return (
    <BaseModal
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx("ui-consent-modal-override", overrideClassNames)}
    >
      {children}
    </BaseModal>
  );
};

CreateReservationModal.Content = CreateReservationModalContent;
CreateReservationModal.Footer = CreateReservationModalFooter;

export { CreateReservationModal };
